import * as types from './constants'

const initialState = {
	groupData: [],
	statuses: [],
	selectedStatuses: [],
	selectedStatusesStatus: [],
	selectedPastDue: null,
	// pastDue: [
	//   {name: 'Active'},
	//   {name: 'Inactive'}
	// ],
	// courseTypes: [
	//   {value: 1, name: 'Core Training'},
	//   {value: 2, name: 'Initiative Training'}
	// ],
	selectedCourseType: [],
	selectedCourseTypeValues: [],
	searchValue: '',
	searchValueOnClick: '',
	coursesData: [],
	reportsLoading: false,
}
const reportReducer = (state = initialState, action) => {
	switch (action.type) {
		case types.SET_STATUSES:
			return {
				...state,
				statuses: action.statuses,
			}
		case types.SET_SELECTED_STATUESES:
			return {
				...state,
				selectedStatuses: action.statuses,
			}

		case types.SET_GROUP_DATA:
			return {
				...state,
				groupData: action.groupData,
			}
		case types.SET_SELECTED_STATUESES_NR:
			return {
				...state,
				selectedStatusesStatus: action.selectedStatusesStatus,
			}
		case types.SET_PAST_DUE:
			return {
				...state,
				selectedPastDue: action.selectedPastDue,
			}
		case types.SET_SELECTED_COURSE_TYPE:
			return {
				...state,
				selectedCourseType: action.selectedCourseType,
			}
		case types.SET_SELECTED_COURSE_TYPE_VALUES:
			return {
				...state,
				selectedCourseTypeValues: action.selectedCourseTypeValues,
			}
		case types.SET_SEARCH_VALUE:
			return {
				...state,
				searchValue: action.searchValue,
			}
		case types.SET_SEARCH_VALUE_ON_CLICK:
			return {
				...state,
				searchValueOnClick: action.value,
			}
		case types.SET_COURSES_DATA:
			return {
				...state,
				coursesData: action.coursesData,
			}
		case types.SET_REPORTS_LOADING:
			return {
				...state,
				reportsLoading: action.value,
			}
		default:
			return state
	}
}

export default reportReducer
